import { gql } from "@apollo/client";

export default gql`
query GetSurveys($survey_language: String, $trial_type: String, $survey_type: String, $completed_dateNotNull: Boolean) {
  surveys(trial_type: $trial_type, survey_language:$survey_language, survey_type: $survey_type, completed_dateNotNull: $completed_dateNotNull) {
    id
    title
    completed_date
    section_2_completed_date
    section_3_completed_date
    user {
      id
      user_name
      section_1_completed_date
    }
    survey_type
    
    pc_edge
    pc_chrome
    pc_firefox
    pc_other
    mac_safari
    mac_chrome
    mac_firefox
    mac_other
    ios_tablet
    ios_smartphone
    ios_safari
    ios_edge
    ios_chrome
    ios_firefox
    ios_other
    android_tablet
    android_smartphone
    android_edge
    android_chrome
    android_firefox
    android_other
    vpn
    
    ease_of_access 
    ease_of_navigation 
    clear_instructions 
    understood_expectation
    interesting_manner
    pe_realistic
    pe_useful
    balance_pe_vs_course
    instructions_appropriate
    reading_listening_appropriate
    time_taken
    module_length  
    overall_assessment 
    recommendations 
    observations 
    improved_proficiency
    improved_job_performance
    challenging_aspects
    most_useful
    least_useful
    
    focused_on_material
  }
}
`